import React, { useEffect, useState } from "react";
import { mappingData } from "../data/QuestionnaireData";
import DataGridComponent from "../commonfields/grid/DataGridComponent";
import { defaultGridConfig } from "../config/DataGridConfig";
import { mappingColumns } from "../config/QuestionnaireConfig";
import { useNavigate } from "react-router-dom";
import { CellClickArgs, CellMouseEvent } from "react-data-grid";
import { RoutesEnum, SidebarEnum } from "../tsmodels/RoutesModel";
import "./pages.scss";
import { getSidebarIcon } from "../config/SideBarConfig";
import TextInput from "../commonfields/inputs/TextInput";
import { ReactComponent as SearchIcon } from "../images/search-icon.svg"
import Appservice from "../services/appservice";
import { getCategoriesByQuestioanrieId, getMappingList, getQuestionarieList, getQuestionarieTypes } from "../helpers/ServiceSections";

const MappingsListPage = () => {
  const navigate = useNavigate();

  // states
  const [mappingSearch, setMappingSearch] = useState("");
  const [MData, setMappingData] = useState<any>([])
  const [loader, setLoader] = useState<boolean>(false)
  const service = new Appservice();

 
      
  


  // const
  // mapping columns for the list
  const columns = mappingColumns;

  // mapping data for the list
  const data = MData as any;

  // mapping data for the list
  const config = { ...defaultGridConfig, sortable: true };

  // funcs - handlers
  const handleQuestionnaireSearch = (e: any) => {
    setMappingSearch(e?.target?.value);
  };

  const onCellClick = (
    args: CellClickArgs<any, unknown>,
    event: CellMouseEvent
  ) => {
    args?.row?.mappingId &&
      navigate(`${RoutesEnum.DETAILS}/${args?.row?.mappingId}`);
  };

  // funcs-Api call
   
  const getMappingQuestion = () => {
    const payLoad = getMappingList;
    setLoader(true);
    service
      .getQuestionnaireList(payLoad)
      .then((res) => {
        setMappingData(res?.data)
   
      })
     
      .finally(() => {
        setLoader(false);
      });
  };
  

  // funcs - render 
  // useEffect
  useEffect(() => {
    getMappingQuestion();
  }, []);

  return (
    <div className="mapping-list-page">
      <div className="subheader-container">
        <div className="subheader-left">
          <div className="subheader-icon">
            {getSidebarIcon(SidebarEnum.MAPPINGS)}
          </div>
          <div className="subheader-title">Mapping Library</div>
        </div>
        <div className="subheader-right">
          <div className="subheader-input-container">
            <TextInput
              className="subheader-input"
              value={mappingSearch}
              onChange={handleQuestionnaireSearch}
              placeholder="Search for a mapping"
            />
            <SearchIcon className="search-icon" />
          </div>
        </div>
      </div>
      <div className="mapping-list-table">
        <DataGridComponent
          gridRows={data}
          gridColumns={columns}
          config={config}
          onCellClick={onCellClick}
          searchParams={{
            fieldName: 'mappingName',
            value: mappingSearch
          }}
        />
      </div>
    </div>
  );
};

export default MappingsListPage;
